<template>
    <div>
          <!-- 面包屑导航 -->
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item @click.native="gohome" ><a>首页</a></el-breadcrumb-item>
            <el-breadcrumb-item>月缴单位</el-breadcrumb-item>
            <el-breadcrumb-item>人员有变化申报</el-breadcrumb-item>
          </el-breadcrumb>
         
       <!-- 卡片视图区 步骤一 -->
          <el-card id="card_st" v-show="cardshow">
              <div slot="header" class="clearfix">
                    <span style="font-size: 24px;font-weight: 500;">人员有变化申报</span>
              </div> 
              <div  style="padding-top: 10px;text-align: center;">
                <span style="color: red;">{{messages}}</span>
              </div>
             
              
          
          </el-card>
      

</div>


</template>
<script>
    import Vue from 'vue'
    export default {
        inject: ['reload'],
        data() {

            return {
                user: '',
                // 请求数据 
                yjblShow: false,
                piccnew: {},
                updateuser: {},
                messages: '',
                cardshow: false

            }

        },
        created() {

            console.log(JSON.parse(window.sessionStorage.getItem("user")));
            this.user = JSON.parse(window.sessionStorage.getItem("user"));
            window.addEventListener('setItem', () => {

                this.user = JSON.parse(window.sessionStorage.getItem("user"));

            })
            this.updateuser = this.user;
            if (this.updateuser.usertype != null) {
                this.usertype = (this.updateuser.usertype.substring(1) - 0) - 1;
            } else {
                this.$message({
                    message: "请单位信息维护",
                    type: 'warning'
                });
                this.dialogFormVisible = true;
            }
            this.dqsfbl();
            // this.piccnew.aab001 = this.user.aab001;
            // this.piccnew.spaced = this.user.lxrname;
            // this.piccnew.spacee = this.user.lxrphone;
            // let moment = require('moment');
            // this.piccnew.timeaction = moment().startOf('month').subtract('month', -1).format("YYYY-MM-DD"); //下个月初
            // this.piccnew.timeend = moment().endOf('month').subtract('month', -1).endOf('month').format("YYYY-MM-DD") //下个月末




        },

        methods: {

            //人员无变化申报
            async nochangeRenewal() {
                // 弹框
                let moment = require('moment');
                const confirmResult = await this.$confirm('确定无变化办理下一个月？', '提示', {
                        async: false,
                        cache: false,
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).catch(err => err)
                    // 成功删除为confirm 取消为 cancel
                if (confirmResult != 'confirm') {
                    // this.reload();
                    this.$router.push("/changeRenewal");
                    return this.$message.info("已取消提交");

                    // 
                }
                this.piccnew.timeaction = moment().startOf('month').subtract('month', -1).format("YYYY-MM-DD");
                this.piccnew.timeend = moment().endOf('month').subtract('month', -1).endOf('month').format("YYYY-MM-DD");
                this.piccnew.spacea = '';
                console.log(this.piccnew)
                const {
                    data: res
                } = await this.$http.post("nochangeRenewal", this.piccnew, {

                }).catch((err) => {

                    this.$message.error("操作失败！！！")
                    window.sessionStorage.setItem('activePath', "/sljl");
                    this.$router.push("/sljl");
                    this.reload();
                });

                if (res != "success") {
                    return this.$message.error("操作失败！！！");
                    window.sessionStorage.setItem('activePath', "/sljl");
                    this.$router.push("/sljl");
                    this.reload();
                }
                this.$message.success("操作成功！！！");
                window.sessionStorage.setItem('activePath', "/sljl");
                this.$router.push("/sljl");
                this.reload();


            },
            //判断当前月是否办理
            async dqsfbl() {

                let moment = require('moment');
                var formData = new FormData()
                formData.append('aab001', this.user.aab001);
                formData.append('timeaction', '' + moment().startOf('month').format("YYYY-MM-DD"));
                formData.append('timeend', '' + moment().endOf('month').format("YYYY-MM-DD"));
                // 调用post请求
                const {

                    data: res
                } = await this.$http.post("sfbl", formData, {}, {

                });
                if (res.sfblCount == 0) {
                    this.messages = '不可办理:无本月办理记录!请点击受理记录查看';
                    this.cardshow = true;
                } else {
                    this.piccnew = res.sfbl;
                    this.sfbl();


                }
            },

            //判断是否办理
            async sfbl() {

                let moment = require('moment');
                var formData = new FormData()
                formData.append('aab001', this.user.aab001);
                formData.append('timeaction', '' + moment().startOf('month').subtract('month', -1).format("YYYY-MM-DD"));
                formData.append('timeend', '' + moment().endOf('month').subtract('month', -1).endOf('month').format("YYYY-MM-DD"));
                // 调用post请求
                const {

                    data: res
                } = await this.$http.post("sfbl", formData, {}, {


                });
                if (res.sfblCount > 0) {
                    this.messages = '已申请!请点击受理记录查看';
                    this.cardshow = true;

                } else {

                    this.nochangeRenewal();
                }
            },
            //返回首页
            gohome() {
                window.sessionStorage.setItem('activePath', "/welcome");
                this.$router.push("/welcome");
                this.reload();   
            }

        }
    };
</script>
<style lang="less" scoped>
    #card_st {
        width: 80%;
        margin: auto;
    }
    
    .text {
        font-size: 16px;
        width: 600px;
        padding-left: 100px;
    }
    
    .item {
        margin-bottom: 24px;
    }
    
    .el-alert {
        margin-top: 10px;
    }
    
    /deep/.el-radio__label {
        font-size: 14px;
        padding-left: 10px;
        display: none;
    }
</style>

<style>
    //修改table一列内容超出显示宽度
    .el-tooltip__popper {
        max-width: 50%;
    }
    
    .el-tooltip__popper,
    .el-tooltip__popper.is-dark {
        background: rgb(48, 65, 86) !important;
        color: #fff !important;
        line-height: 24px;
    }
</style>